import { useEffect, useState } from "react";
import { SelectOption } from "../types";
import { useUserQuery } from "../graphql/menu.hooks";
import { useUserAccessQuery } from "../graphql/access.hooks";

type Params = {
  projectId?: number;
  setFolders?: React.Dispatch<React.SetStateAction<any[] | undefined>>;
};

export const useGetOptions = ({ projectId, setFolders }: Params) => {
  const { data: userData } = useUserQuery();
  const { data: userAccesses, loading: accessLoading } = useUserAccessQuery();

  const [domainOptions, setDomainOptions] = useState<SelectOption[]>([]);
  const [folderOptions, setFolderOptions] = useState<SelectOption[]>([]);

  const user = userData ? userData.user : undefined;

  useEffect(() => {
    if (!user) return;
    const domainsFromAccess =
      userAccesses?.userAccess?.userAccessArray?.map((item) => item?.domain) ||
      [];

    const filteredOptions = [...user.domains, ...domainsFromAccess].filter(
      (domain) => domain !== null
    );

    setDomainOptions(
      filteredOptions?.map((item) => ({
        value: item.id,
        label: item.title,
      }))
    );
  }, [user, userAccesses?.userAccess?.userAccessArray]);

  useEffect(() => {
    if (user && projectId && setFolders) {
      const domainsFromAccess =
        userAccesses?.userAccess?.userAccessArray?.map(
          (item) => item?.domain
        ) || [];

      const folders = [...user.domains, ...domainsFromAccess].find(
        (domain) => domain?.id === +projectId
      )?.folders;

      setFolders(folders);
      setFolderOptions(
        folders?.map(({ id, title }) => {
          return { value: id, label: title };
        })
      );
    }
  }, [projectId, user, userAccesses?.userAccess?.userAccessArray, setFolders]);

  return { domainOptions, folderOptions, accessLoading };
};
